import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import AppContext from 'context/Context';
import CustomAudioPlayer from './CustomAudioPlayer';
import { parseMessageData } from '../../utils/messageHelpers';

/**
 * Subcomponente para renderizar cada burbuja de mensaje individual
 */
const TicketMessageItem = ({ msg, index, onOpenLightbox, onMediaLoad }) => {
  const { config: { isDark } = {} } = useContext(AppContext);
  const { isAgent, author, text, timeStr, isSticker, isImage, isAudio, isVideo, isDocument, mediaUrl } = parseMessageData(msg, index);

  if (isSticker && mediaUrl) {
    return (
      <div className={`d-flex flex-column ${isAgent ? 'align-items-end' : 'align-items-start'}`}>
        <div className="position-relative">
          <img
            src={mediaUrl}
            alt="Sticker de WhatsApp"
            style={{ width: '130px', height: '130px', objectFit: 'contain', cursor: 'pointer' }}
            onClick={() => onOpenLightbox(mediaUrl)}
            onLoad={onMediaLoad}
          />
          <div className="d-flex align-items-center justify-content-end gap-1 mt-1" style={{ fontSize: '0.68rem', color: isDark ? '#8696a0' : '#64748b' }}>
            <span className="fw-medium">{author}</span>
            <span>•</span>
            <span>{timeStr}</span>
            {isAgent && <FontAwesomeIcon icon={faCheck} style={{ fontSize: '0.65rem' }} />}
          </div>
        </div>
      </div>
    );
  }

  const bubbleBg = isDark
    ? (isAgent ? '#005c4b' : '#202c33')
    : (isAgent ? '#d9fdd3' : '#ffffff');

  const bubbleColor = isDark ? '#e9edef' : '#111b21';
  const bubbleBorder = isDark
    ? (isAgent ? 'none' : '1px solid #2a3942')
    : (isAgent ? 'none' : '1px solid #e9edef');

  const authorColor = isDark
    ? (isAgent ? '#d1fae5' : '#38bdf8')
    : '#111b21';

  return (
    <div className={`d-flex flex-column ${isAgent ? 'align-items-end' : 'align-items-start'} mb-1`}>
      <div
        className="position-relative shadow-sm"
        style={{
          maxWidth: '70%',
          minWidth: '120px',
          backgroundColor: bubbleBg,
          color: bubbleColor,
          borderRadius: isAgent ? '8px 0px 8px 8px' : '0px 8px 8px 8px',
          border: bubbleBorder,
          padding: '8px 12px 6px 12px',
          fontSize: '0.88rem',
          lineHeight: '1.4'
        }}
      >
        {/* 1. Render Imagen con visor */}
        {isImage && mediaUrl && (
          <div className="mb-1 text-center overflow-hidden rounded-2">
            <img
              src={mediaUrl}
              alt="Imagen de WhatsApp"
              className="img-fluid"
              style={{ maxHeight: '280px', width: '100%', objectFit: 'cover', cursor: 'zoom-in' }}
              onClick={() => onOpenLightbox(mediaUrl)}
            />
          </div>
        )}

        {/* 2. Render Video */}
        {isVideo && mediaUrl && (
          <div className="mb-1 overflow-hidden rounded-2">
            <video controls className="w-100" style={{ maxHeight: '280px' }} src={mediaUrl} />
          </div>
        )}

        {/* 3. Render Audio / Nota de voz estilizada */}
        {isAudio && mediaUrl && (
          <div className="mb-1">
            <CustomAudioPlayer src={mediaUrl} isAgent={isAgent} />
          </div>
        )}

        {/* 4. Render Documento */}
        {isDocument && mediaUrl && (
          <div
            className="mb-1 p-2 rounded d-flex align-items-center justify-content-between gap-2 border"
            style={{
              backgroundColor: isDark ? '#182635' : '#f8fafc',
              borderColor: isDark ? '#2a3942' : '#e2e8f0',
              color: bubbleColor
            }}
          >
            <span className="text-truncate" style={{ fontSize: '0.8rem' }}>
              📄 {text || 'Documento adjunto'}
            </span>
            <a href={mediaUrl} download target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-primary px-2 py-0" style={{ fontSize: '0.75rem' }}>
              Descargar
            </a>
          </div>
        )}

        {/* Caption o texto del mensaje */}
        {text && !text.startsWith('[') && (
          <div className="mb-1 text-break" style={{ whiteSpace: 'pre-wrap' }}>
            {text}
          </div>
        )}

        {/* Footer del mensaje estilo WhatsApp: Autor (si es agente) + Hora + Check */}
        <div
          className="d-flex align-items-center justify-content-end gap-1 mt-1"
          style={{ fontSize: '0.68rem', color: isDark ? '#8696a0' : '#64748b', userSelect: 'none' }}
        >
          {author && (
            <>
              <span className="fw-bold" style={{ fontSize: '0.68rem', color: authorColor }}>{author}</span>
              <span>•</span>
            </>
          )}
          <span>{timeStr}</span>
          {isAgent && (
            <FontAwesomeIcon icon={faCheck} style={{ fontSize: '0.62rem', color: '#53bdeb', marginLeft: '2px' }} />
          )}
        </div>
      </div>
    </div>
  );
};
export default TicketMessageItem;
